"use client";

import { useEffect, useState } from "react";

// Subscribe to a CSS media query and return the current match.
// Returns `null` until first hydration so SSR and initial CSR agree.
// Mirrors the pattern from useReducedEnvironment but exposes the raw
// query so we can dedupe matchMedia logic across components.
export function useMatchMedia(query: string): boolean | null {
  const [matches, setMatches] = useState<boolean | null>(null);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const update = () => setMatches(mql.matches);

    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, [query]);

  return matches;
}
